$(document).ready(function(){
  //Sticky Menu
  $(".nav-bar").stick_in_parent();

  //Lazy Loading
  $('.lazy').imagesLoaded()
  	.progress( function( instance, image ) {
    	var $item = $( image.img ).parents( '.lazy' );
    	$item.addClass('loaded');
    	$(document.body).trigger("sticky_kit:recalc");
  });

  //Product Description Toggles
  $('.product-description--more').click(function(){
  	$('.product-description, .product-description--full').toggle();
  	$(document.body).trigger("sticky_kit:recalc");
  });

  //Mask Overlay with Drawers
  $('#drawer_mask').click(function(){
  	timber.RightDrawer.close();
  	timber.LeftDrawer.close();
  });

  //Background Colour for Lookbooks
  if($('.lookbook').length) {
    var $bgcol = $('.lookbook').attr('data-bg');
    $('body').css('background-color',$bgcol);

    var $textwhite = $('.lookbook').attr('data-text-white');
    if( $textwhite == 'true' ) {
      $('body').addClass('white');
    }
  }

  //Loading Sequence
  /*if( $('#loading').length ) {
    $('#loading').imagesLoaded(function(){
      var $total = $('.loading_item').length;
      var $slides = $('.loading_item');
      $slides.first().addClass('active current');
      var loadnextslide = window.setInterval(function(){
        var $current = $('.loading_item.current');
        if ( $current.is(':last-child') ) {
          $('#loading').addClass('removed');
          $('.home-blocks').addClass('active');
          $('body').removeClass('loading');
          clearInterval(loadnextslide);
          console.log('Home Loaded In');
        } else {
          $current.next().addClass('active current');
        }
        console.log('Slide Loaded');
      }, 350);
    });
  } else {
    $('body').removeClass('loading');
  }*/
  $('body').removeClass('loading');
  $('.home-blocks').addClass('active');

  //Show Lookbook nav if on lookbook page
  if( $('.lookbook-item').length ) {
    $('#lookbook_nav').show();
  }

  //FAQs
  $('.faq-item .question').click(function(){
    $(this).parent().find('.answer').toggle();
  });

  //Popups
  $('#popup_mask, #popup .close').click(function(){
    $('#popup_mask, #popup').removeClass('active');
  });
   $('.popup_button').click(function(){
    $('#popup_mask, #popup').addClass('active');
  });

  //Newsletter Signup
  if ( Cookies.get('signup') ) {
  } else {
    setTimeout(function(){
      $('#signup').addClass('open');
      Cookies.set('signup', 'seen', { expires: 1 });
    }, 4000);
  }
  $('#signup .close').click(function(){
    $('#signup').removeClass('open');
  });

  //Site Popup
  if ( Cookies.get('seen-popup') ) {
  } else {
    $('#site_popup').removeClass('closed');
  }
  $('#site_popup .close').click(function(){
    $('#site_popup').addClass('closed');
    Cookies.set('seen-popup', 'seen', { expires: 1 });
  });

  //Field Notes
  $('.field-notes_article-content p').each(function(){
    if($(this).find('img').length) {
      $(this).addClass('wide');
    }
  })
  
})

$(window).load(function(){
  //Recalc Sticky on page load
	$("#product_details").stick_in_parent();
	$(document.body).trigger("sticky_kit:recalc");
})